<!-- boardtravelexpenselote.vue -->
<!-- Prestacao de Contas > Despesas de Viagem: uma linha por LOTE, igual ao tableboard do Diversos.
     Monta os lotes a partir do GetAllUsuarioByStatusDiretoria (uma linha por funcionario). Aprovar /
     reprovar vai pelo ApproveLoteBoard / DisaApproveLoteBoard: so as despesas dos lotes marcados mudam,
     nunca as do mesmo funcionario em outro lote. -->
<template>
  <div>
    <Tables ref="tableGridLoteViagem"
      :columns="['Lote', 'Funcionários Vinculados', 'Valor Total']"
      :showSearch="false"
      :showPrint="false"
      :newHeaderStatus="true"
      :showDownload="false"
      :showCheckInput="true"
      :showReload="false"
      @check="checkAll"
      :showFullscreen="false"
      >
      <tr v-for="obj in lotes" :key="obj.chave">
        <td class="text-center" style="font-size: 20px; vertical-align: middle;"><input :data-lote="obj.chave" type="checkbox" class="checkbox-lote-viagem"/></td>
        <TableColumn :IsText="true" v-on:Edit="onSelect(obj)" :status="1" :value="obj.numeroLote !== null ? obj.numeroLote : 'Sem lote'" />
        <TableColumn :IsText="true" v-on:Edit="onSelect(obj)" :status="1" :value="obj.funcionarios.length" />
        <TableColumn :IsText="true" v-on:Edit="onSelect(obj)" :status="1" :value="formatMoney(obj.totalGasto)" />
      </tr>
      <template #ButtonsAprova>
        <div class="buttonaprova">
          <button class="btn-rep" @click="disaApprove"><i class="fas fa-thumbs-down"></i> Reprovar</button>
          <button class="btn-appr" @click="approve"><i class="fas fa-thumbs-up"></i> Aprovar</button>
        </div>
      </template>
    </Tables>
  </div>
</template>

<script>
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'

// Chave do lote de uma linha por funcionario. `numeroLote` nulo = adiantamento ainda sem lote.
export const chaveDoLote = (linha) => (linha.numeroLote !== null && linha.numeroLote !== undefined ? String(linha.numeroLote) : 'sem-lote')

export default {
  name: 'BoardTravelExpenseLote',
  mixins: [ActionsForm],
  props: {
    dataexpensesResponse: {
      type: Object,
      default: () => { return {} }
    }
  },
  computed: {
    lotes () {
      const linhas = (this.dataexpensesResponse && this.dataexpensesResponse.data && this.dataexpensesResponse.data.data) || []
      const porLote = {}
      linhas.forEach(x => {
        const chave = chaveDoLote(x)
        if (!porLote[chave]) {
          porLote[chave] = { chave, numeroLote: chave === 'sem-lote' ? null : x.numeroLote, funcionarios: [], totalGasto: 0 }
        }
        porLote[chave].funcionarios.push(x.funcionarioId)
        porLote[chave].totalGasto += (x.despesasViagemTotalDto && x.despesasViagemTotalDto.totalGasto) || 0
      })
      return Object.values(porLote).sort((a, b) => (b.numeroLote || 0) - (a.numeroLote || 0))
    }
  },
  watch: {
    lotes (value) {
      this.uncheckAll()
      this.$refs.tableGridLoteViagem.LoadAllByData({ data: { code: 200, data: value, count: value.length } })
    }
  },
  methods: {
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    onSelect (obj) {
      this.$emit('selecionarLote', obj.chave)
    },
    checkAll (e) {
      document.querySelectorAll('.checkbox-lote-viagem').forEach(x => { x.checked = e.checked })
    },
    uncheckAll () {
      document.querySelectorAll('.checkbox-lote-viagem').forEach(x => { x.checked = false })
    },
    lotesMarcados () {
      const recorte = { FuncionarioIds: [], Lotes: [], SemLote: false }
      document.querySelectorAll('.checkbox-lote-viagem').forEach(x => {
        if (!x.checked) return
        const lote = this.lotes.find(l => l.chave === x.dataset.lote)
        if (!lote) return
        recorte.FuncionarioIds.push(...lote.funcionarios)
        if (lote.numeroLote === null) recorte.SemLote = true
        else recorte.Lotes.push(lote.numeroLote)
      })
      return recorte
    },
    approve () {
      const recorte = this.lotesMarcados()
      if (!recorte.FuncionarioIds.length) return toast.info('Selecione pelo menos um lote')
      loading.push()
      TravelExpenseRepository.ApproveLoteBoard(recorte)
        .then(() => {
          loading.pop()
          this.$emit('needGetDespesasViagemDiretoria')
          toast.success('Aprovações realizadas com sucesso')
        })
        .catch(() => {
          loading.pop()
          toast.error('Ocorreu um erro')
        })
    },
    disaApprove () {
      const recorte = this.lotesMarcados()
      if (!recorte.FuncionarioIds.length) return toast.info('Selecione pelo menos um lote')
      loading.push()
      TravelExpenseRepository.DisaApproveLoteBoard(recorte)
        .then(() => {
          loading.pop()
          this.$emit('needGetDespesasViagemDiretoria')
          toast.success('Desaprovações realizadas com sucesso')
        })
        .catch(() => {
          loading.pop()
          toast.error('Ocorreu um erro')
        })
    }
  }
}
</script>

<style scoped>
  .buttonaprova{
    height: 2rem;
    display: flex;
    gap:10px;
  }
  .btn-rep{
    width: 10vw;
    background: red;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
  }
  .btn-appr{
    width: 10vw;
    background: #008144;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
  }
  .btn-rep:hover{
    background: rgb(179, 1, 1);
  }
  .btn-appr:hover{
    background: #01532d;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/finance/accountability/components/travelExpenseTab/components/boardtravelexpenselote/boardtravelexpenselote.vue